import { YStack } from '@bounty/creators-design-system'
import { ReactNode } from 'react'

export const MigrationLayout = ({ children }: { children: ReactNode }) => {
  return (
    <YStack backgroundColor="white" flex={1} minHeight="100vh">
      {children}
    </YStack>
  )
}
